module.exports = __webpack_public_path__ + "static/media/eea-logo.55fb94a4.svg";